import {observer} from "mobx-react-lite";
import GameTeam from "./../../Games/GameTeam";
import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import clubStore from "../../../storage/ClubStore";

const NewGameTeam = () => {
    const location = useLocation()
    useEffect(() => {
        clubStore.tournament.resetGameTeam()
    }, [location.pathname])
    return (
        <GameTeam role={'MGR'}/>
    )
}

export default observer(NewGameTeam)